import Body from "./components/Body";
import Create from "./components/Create";
import React from "react";
// import values from "../../../../values";

import { Container } from "react-bootstrap";
import {
  BreadCrumb,
  CustomView,
  TableHeader,
  TableLoading,
} from "../../../../components";
import values from "../../../../values";
import "./index.scss";
import { Components } from "../FindTransactionScreen/components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import { useTranslation } from "react-i18next";
// import {TransactionContext} from "../../../../context";
// import {Pagination, PropertyInformationModal, TableHeader} from "../../../../components";

type Props = {
  rqData: any;
  showModalData: any;
};

const FinancialGroupScreen = (props: Props) => {
  // const {setShowModal, showModal, allTransactionFilters, setAllTransactionFilters} = React.useContext(TransactionContext);

  // const {status: showModalStatus, data: showModalData} = props.showModalData;
  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const { t } = useTranslation();

  return (
    <section id="financial-group-screen">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          {writePermission === "true" && <Create />}

          {/* <Search /> */}
        </CustomView.Column>
      </CustomView.Row>
      <Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader
              headers={values.tableHeaders.FINANCIAL_GROUP_HEADERS.map((item) =>
                t(item)
              )}
            />
            {props.rqData?.getAllFinancilalGroup?.status === "loading" ? (
              <TableLoading />
            ) : (
              <Body data={props.rqData?.getAllFinancilalGroup?.data} />
            )}
          </table>
        </div>
      </Container>

      {/* {showModalStatus === "success" && (
        <PropertyInformationModal
          propertyData={showModalData?.result}
          open={showModal === "SHOW"}
          onClose={() => setShowModal("NONE")}
        />
      )} */}

      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 20 && (
          <div className="pagination">
            {/* <Pagination
            page={allTransactionFilters?.page}
            totalPages={props.rqData?.data?.result?.totalPages}
            onPaginate={(page: number) =>
              setAllTransactionFilters({
                ...allTransactionFilters,
                page: page,
              })
            }
          /> */}
          </div>
        )}
    </section>
  );
};

export default FinancialGroupScreen;
